import { HttpContextToken } from "@angular/common/http";

/**
 * Opts a request out of the session headers added by AuthInterceptor.
 *
 * Use this for requests that are not authenticated and therefore must not wait on the session,
 * such as the app-settings fetch that AuthService itself depends on to build its API url.
 *
 * Unlike a marker header, an HttpContext token is never serialized onto the wire, so the
 * interceptor has nothing to strip off the request.
 */
export const SKIP_AUTH_HEADERS = new HttpContextToken<boolean>(() => false);
